import React from "react";

interface TitleWidgetProps {
  title?: string;
  subtitle?: string;
  size?: "small" | "medium" | "large";
  align?: "left" | "center" | "right";
}

const TitleWidget: React.FC<TitleWidgetProps> = ({
  title = "Title",
  subtitle,
  size = "medium",
  align = "left",
}) => {
  const sizeClasses = {
    small: "text-lg",
    medium: "text-2xl",
    large: "text-3xl",
  };

  const alignClasses = {
    left: "text-left",
    center: "text-center",
    right: "text-right",
  };

  return (
    <div className={`p-4 ${alignClasses[align]}`}>
      <h1 className={`font-bold text-gray-900 ${sizeClasses[size]}`}>
        {title}
      </h1>
      {subtitle && <p className="text-gray-600 mt-1 text-sm">{subtitle}</p>}
    </div>
  );
};

export default TitleWidget;
